import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COMPANY } from "@/lib/constants";

export default function Hero({ onCta }) {
  return (
    <section
      id="hero"
      className="relative overflow-hidden grain-bg"
    >
      <div
        className="absolute inset-0 -z-10"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(250,250,245,0.85) 0%, rgba(250,250,245,0.94) 100%), url('https://images.unsplash.com/photo-1782939355849-4a748ada9c84?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="max-w-6xl mx-auto px-6 pt-16 pb-24 lg:pt-24 lg:pb-32 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 fade-slide">
            <div className="inline-flex items-center gap-2 bg-white/70 border border-[#E5E7EB] text-[#5A6B34] text-xs font-medium py-1.5 px-3 rounded-full mb-6">
              <Sparkles className="w-3.5 h-3.5" strokeWidth={2} />
              Persönlich · Zuverlässig
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#1A201A] tracking-tight leading-[1.05]">
              Alles rund <span className="blessing-gradient-text">ums Haus</span>
              <span className="block text-[#5C6B5D] text-2xl sm:text-3xl lg:text-4xl font-medium mt-4">
                Ihr Rundum-Sorglos-Paket
              </span>
            </h1>
            <p className="mt-6 text-lg text-[#4A5D4E] max-w-2xl leading-relaxed">
              Rundum Service für Garten und Haus, Objektpflege – professionell & zuverlässig
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Button
                data-testid="hero-cta-btn"
                onClick={onCta}
                className="rounded-full bg-[#6B7F3E] hover:bg-[#5A6B34] text-white text-base h-12 px-7 shadow-sm"
              >
                Jetzt Termin sichern
                <ArrowRight className="ml-1 w-4 h-4" />
              </Button>
              <a
                href="#leistungen"
                data-testid="hero-services-link"
                className="text-sm font-medium text-[#2C3E2D] hover:text-[#6B7F3E] underline underline-offset-4 decoration-[#C4CFB1] transition-colors"
              >
                Leistungen ansehen
              </a>
            </div>

          </div>

          <div className="lg:col-span-5 fade-slide-2 relative">
            <div className="relative rounded-2xl overflow-hidden shadow-lg ring-1 ring-[#E5E7EB]">
              <img
                src="/marvin_blessing.jpg"
                alt="Marvin Blessing, Inhaber von Blessing Dienstleistungen"
                className="w-full h-[520px] object-cover object-[50%_25%]"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#1A201A]/85 via-[#1A201A]/40 to-transparent p-6 pt-16">
                <div className="text-[#C4CFB1] text-xs font-medium uppercase tracking-wider">Inhaber</div>
                <div className="text-white font-display text-xl mt-1">Marvin Blessing</div>
                <div className="text-white/80 text-sm mt-0.5">Ihr persönlicher Ansprechpartner</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
